module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "sidebar"
  }, [_c('p', {
    staticClass: "CT-RECTO"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("“Every day is Children’s Day!”")])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('p', {
    staticClass: "COT"
  }, [_vm._v("Kids get to hear this one every May and June, as soon as they realize that moms and dads both get a special day for breakfast in bed and the presentation of macaroni-and-glitter handicrafts—but that no greeting cards are ever available for the other members of the family. There are certainly "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("many")]), _vm._v(" other days of the year when adults wait on kids hand and foot (just the days that end with “y,” I’ve found). But when kids ask, “How come there’s no such thing as Children’s Day?” a more accurate, less annoying answer would be, “There is! In fact, there are several.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Almost every nation on Earth celebrates a special day for children in one way or another. When I was a kid living in South Korea, it was a huge national holiday. We got May 5 off from school, making it a distinct improvement over Mother’s Day and Father’s Day—always Sundays, and you still have to go to church, even! In 1954, the United Nations declared every November 20 to be Universal Children’s Day, a time to work for the international well-being and cooperation of children. In the United States, church observances of Children’s Day actually go back to the 1850s, predating the setting aside of any specific day for mothers and fathers. Both Presidents Clinton and Bush decreed a Sunday in early June to be “National Child’s Day”; President Obama moved the observance to the UN-approved November 20. Normally, there’d be grumbling in some quarters about his surrendering our sovereignty to the UN’s international socialist agenda, but I’m sure we all agree that Children Are Our Future and we wouldn’t want to spoil that with partisan bickering, right?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "height": "18",
      "src": "images/white.jpg",
      "width": "120"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "TF"
  }, [_vm._v("FALSE.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7249d7aa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch03.vue
// module id = 81
// module chunks = 0